import { useShoppingCart } from '@hooks/cart/useShoppingCart';
import { useLocalOrRemoteCustomer } from '@hooks/useLocalOrRemoteCustomer';
import { useDeliveryBarError as useDeliveryBarErrorBase } from '@monofront/business/hooks/useDeliveryBarError';
import { useDeliveryBar } from '@context/DeliveryBarContext';

export const useDeliveryBarErrorsWithContext = () => {
  const shoppingCartContext = useShoppingCart();
  const { resolvedCustomer: customer } = useLocalOrRemoteCustomer();
  const { waitingProduct } = useDeliveryBar();

  return useDeliveryBarErrorBase({
    shoppingCart: shoppingCartContext?.shoppingCart ?? undefined,
    customer,
    waitingProduct,
  });
};
